export default "__VITE_ASSET__wbj1u8F8RmDot4_Hb5pcTA__"